import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { SponsorDto } from "../../../models/sponsor/dto/sponsor.dto";

export const GET_SPONSOR_QUERY_KEY = (id: string) => ['sponsors', id];
export const useGetSponsor = (id: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_SPONSOR_QUERY_KEY(id),
        queryFn: () => client.fetchApi<SponsorDto, {}>({
            endpoint: `sponsors/admin/${id}`,
            method: 'GET'
        }),
        enabled: !!id,
    });
};
